import React from 'react';
import {Table, Modal, message, Divider, Input, Button} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";
const { TextArea } = Input;

export default class ServerLocationList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            doing: false,
            showMessageDialog: false,
            showConfirmModal: false,
            confirmLoading: false,
            form_params: {}
        }
    }

    componentDidMount() {
        this.loadListData();
    }

    handleFormInputChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (name !== 'remarks') {
            value = value.trim();
        }
        let form_params = this.state.form_params;
        form_params[name] = value;
        this.setState(form_params);
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData() {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/query-server-location-list')
        .then(response => {
            console.debug("query-server-location-list response -> " + response.code);
            this.setState({loading: false});
            if (response.code === 200) {
                this.setState({dataList: response.data})
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(response['msg']);
            }
        }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    resetCache() {
        new WebServerRestClient().DELETE('/admin/reset-server-location-cache')
            .then(response => {
                CommonUtils.log("reset-server-location-cache response -> " + response.code);
                this.setState({doing: false});
                if (response.code === 200) {
                    alert("Reset successfully!")
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({doing: false});
            message.error("Error: " + err.message);
        });
    }

    render() {
        return (
            <div className="container">
                <div className="total_bar">
                    <div className="button_group">
                        <Button type="link" icon="reload" size={"small"} loading={this.state.doing}
                                onClick={this.resetCache.bind(this)}>Reset Cache</Button>
                    </div>
                </div>
                <Table loading={this.state.loading}
                       rowKey={'id'}
                       columns={[
                           {title: 'ID', dataIndex: 'id', align: 'center'},
                           {title: 'ContinentName', dataIndex: 'continentName', align: 'left'},
                           {title: 'ContinentCode', dataIndex: 'continentCode', align: 'center'},
                           {title: 'CountryName', dataIndex: 'countryName', align: 'left'},
                           {title: 'CountryCode', dataIndex: 'countryCode', align: 'center'},
                           {title: 'Location', dataIndex: 'location', align: 'left'},
                           {title: 'Sequence', dataIndex: 'sequence', align: 'center'},
                           {
                               title: 'Status', dataIndex: 'status', align: 'center',
                               render: (value, record) => {
                                   if (value == 1) {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'status', -1)}>
                                               <span style={{color: 'green'}}>Enabled</span>
                                           </a>
                                       )
                                   } else {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'status', 1)}>
                                               <span style={{color: 'red'}}>disabled</span>
                                           </a>
                                       )
                                   }
                               }
                           },
                           {
                               title: 'FNET', dataIndex: 'fnetStatus', align: 'center',
                               render: (value, record) => {
                                   if (value == 1) {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'fnetStatus', -1)}>
                                               <span style={{color: 'green'}}>Enabled</span>
                                           </a>
                                       )
                                   } else {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'fnetStatus', 1)}>
                                               <span style={{color: 'red'}}>disabled</span>
                                           </a>
                                       )
                                   }
                               }
                           },
                           {
                               title: 'PNET', dataIndex: 'pnetStatus', align: 'center',
                               render: (value, record) => {
                                   if (value == 1) {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'pnetStatus', -1)}>
                                               <span style={{color: 'green'}}>Enabled</span>
                                           </a>
                                       )
                                   } else {
                                       return (
                                           <a onClick={() => this.updateStatusModal(record.id, 'pnetStatus', 1)}>
                                               <span style={{color: 'red'}}>disabled</span>
                                           </a>
                                       )
                                   }
                               }
                           },
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                        <a onClick={() => this.showInputModal(record)}>Modify</a>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={false}/>

                <Modal
                    title="Modify Record"
                    destroyOnClose={true}
                    visible={this.state.showConfirmModal}
                    onCancel={() => this.setState({showConfirmModal: false})}
                    onOk={() => this.modifyObject()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">
                    <Input name={'continentName'} placeholder={'continent name'}
                           defaultValue={this.state.form_params.continentName}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <Input name={'continentCode'} placeholder={'continent code'}
                           className="mt_10"
                           defaultValue={this.state.form_params.continentCode}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <Input name={'countryName'} placeholder={'country name'}
                           className="mt_10"
                           defaultValue={this.state.form_params.countryName}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <Input name={'countryCode'} placeholder={'country code'}
                           className="mt_10"
                           defaultValue={this.state.form_params.countryCode}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <Input name={'location'} placeholder={'location'}
                           className="mt_10"
                           defaultValue={this.state.form_params.location}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <Input name={'sequence'} placeholder={'sequence'}
                           className="mt_10"
                           defaultValue={this.state.form_params.sequence}
                           onChange={this.handleFormInputChange.bind(this)}
                           onFocus={this.handleInputFocus.bind(this)}/>
                    <TextArea name={'servers'} rows={5} placeholder={'server list json'}
                              className="mt_10"
                              defaultValue={this.state.form_params.servers}
                              onChange={this.handleFormInputChange.bind(this)}
                              onFocus={this.handleInputFocus.bind(this)}/>
                </Modal>
            </div>
        )
    }

    updateStatusModal(id, type, status){
        let content;
        if (status === 1) {
            content = 'Enable this country?';
        } else {
            content = 'Disable this country?';
        }

        let parameters = this.state.form_params;
        if (type === 'status') {
            parameters = {
                id: id,
                status: status
            }
        } else if (type === 'fnetStatus') {
            parameters = {
                id: id,
                fnetStatus: status
            }
        } else if (type === 'pnetStatus') {
            parameters = {
                id: id,
                pnetStatus: status
            }
        }
        this.setState({form_params: parameters});

        Modal.confirm({
            title: 'Confirm',
            content: content,
            onOk: () => this.modifyObject(),
            confirmLoading: this.state.confirmLoading
        });
    };

    showInputModal(rowData){
        this.setState({
            showConfirmModal: true,
            form_params: rowData
        });
    };

    modifyObject () {
        let form_params = this.state.form_params;
        if (form_params.servers) {
            try {
                const serversJSON = JSON.parse(form_params.servers);
                console.log(serversJSON)
            } catch (err) {
                alert('JSON format error!');
                return
            }
        }
        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/modify-server-location', form_params)
            .then(response => {
            console.log("modify-server-location response -> " + JSON.stringify(response));
            this.setState({confirmLoading: false});
            if (response.code === 200) {
                this.setState({showConfirmModal: false});
                this.loadListData();
            } else {
                message.warn(response['msg']);
            }
        }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

}
